const guia = angular.module('guia', [])

guia.config(['$stateProvider', function($stateProvider) {

    const routes = [
        {
            name: 'cliente.guia',
            url: '/guia/:idGuia',
            params: { showGlobalLoading: { dynamic: true, value: true } },
            component: 'guia.guiaComponent'
        }
    ];

    routes.forEach($stateProvider.state);
}]);